import { Routes_Dashboard } from "@/config/page-routes";
import {
  NetworkError,
  NetworkStatusCodes,
  ClientError,
  ClientStatusCodes,
} from "@/lib/utils/error-definitions";
import { useRouter } from "@/lib/utils/router-events";
import { createClient } from "@/lib/utils/supabase/client";

import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "../ui/button";
import LewkLoader from "../c-loader";
import { GoogleLogo } from "../logo/c-google-logo";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { LewkLogo } from "../c-logo";
import { FacebookLogo } from "../logo/c-facebook-logo";

const LoginCard = () => {
  const supabase = createClient();
  type MagicLinkFormType = { email: string };
  const router = useRouter();
  const { register, handleSubmit } = useForm<MagicLinkFormType>();
  const [isLoggingIn, setIsLoggingIn] = useState<boolean>(false);


  const handleMagicLinkSignIn = async (formData: MagicLinkFormType) => {
    try {
      setIsLoggingIn(true);
      const { data, error } = await supabase.auth.signInWithOtp({
        email: formData.email,
        options: {
          emailRedirectTo: `${window.location.href}`,
        },
      });
      if (error)
        throw new NetworkError(
          error.message,
          error.status as NetworkStatusCodes
        );

      if (data) {
        router.replace(Routes_Dashboard.AUTH_CONFIRM_EMAIL);
      }
    } catch (error) {
      if (error instanceof NetworkError) {
        error.handle();
      } else {
        new ClientError(
          "Something went wrong with logging in with email!",
          ClientStatusCodes.UNDOCUMENTED_ERROR
        ).handle();
      }
    } finally {
      setIsLoggingIn(false);
    }
  };
  const handleOathLogin = async (provider: "google" | "facebook") => {
    try {
      setIsLoggingIn(true);
      const { data, error } = await supabase.auth.signInWithOAuth({
        provider,
        options: {
          redirectTo: `${process.env.NEXT_PUBLIC_BASE_URL}/auth/callback?next=${window.location.pathname}`,
        },
      });

      if (error)
        throw new NetworkError(
          error.message,
          error.status as NetworkStatusCodes
        );
    } catch (error) {
      if (error instanceof NetworkError) {
        error.handle();
      } else {
        new ClientError(
          "Something went wrong with logging in with provider!",
          ClientStatusCodes.UNDOCUMENTED_ERROR
        ).handle();
      }
    } finally {
      setIsLoggingIn(false);
    }
  };

  
  return (
    <>
      <LewkLogo />
      <p className="leading-sm text-lewk-darkgrey">
        Creating an account gives you unlimited outfit generations.
      </p>

      <form
        className=" w-full flex flex-col items-start mt-8 gap-2"
        onSubmit={handleSubmit(handleMagicLinkSignIn)}
      >
        <Label className=" text-center text-[0.9rem] text-lewk-darkgrey">
          Enter your email to sign in or create an account
        </Label>
        <div className="flex gap-2 border border-lewk-grey rounded-full p-1 w-full ">
          <Input
            type="email"
            disabled={isLoggingIn}
            className=" w-full placeholder:text-lewk-darkgrey border-none "
            placeholder="example@email.com"
            {...register("email", { required: true })}
          />
          <Button
            disabled={isLoggingIn}
            type="submit"
            variant={"primary"}
            className=" h-10 px-8 "
          >
            {isLoggingIn ? <LewkLoader className=" size-10" /> : "Login"}
          </Button>
        </div>
      </form>

      <div className=" flex gap-2">
        <Button
          onClick={() => handleOathLogin("google")}
          disabled={isLoggingIn}
          variant={"secondary"}
          size={"base"}
          className="flex gap-2 items-center text-[0.9rem]"
        >
          <GoogleLogo className=" size-6" />
          Google
        </Button>
        {/* <Button
          onClick={() => handleOathLogin("facebook")}
          disabled={isLoggingIn}
          variant={"secondary"}
          size={"base"}
          className="flex gap-2 items-center text-[0.9rem]"
        >
          <FacebookLogo className=" size-6 " />
          Facebook
        </Button> */}
      </div>

      <div className=" flex-1 flex items-end">
        <p className="leading-sm text-lewk-darkgrey  text-[0.9rem]">
          By continuing , you agree to our Terms of Service and Privacy Policy.
        </p>
      </div>
    </>
  );
};

export default LoginCard;
